
const components = {
    MintPanel: {
      heading: "Lifeform #{tokenId}",
      age: "Age: {days} days {hours} hours {seconds} seconds",
      remaining: "Remaining care period:",
      remainingDate:
        "Remaining care period: {days} days {hours} hours {seconds} seconds",
      owner: "Currently in the care of: {owner}",
      give: "GIVE",
      status: "Status: Lifeform #{tokenId} {status}",
    },
    Memoryform: {
      approved: "Would you allow this memoryform to be possibly included in a museum or gallery exhibition someday?",
      finished: "Your Memoryform should be viewable on Opensea very soon.",
    },
    Deathform: {
      finished: "It takes some time for the bridge to transport Lifeforms, as it takes some time to grieve and transition to whatever comes after.", 
    },
    LifeformInfo: {
      mainpara: `Lifeform #{tokenId} was created on {birth} by {creator}. It was cared for {total} times by `
      + `{caretakers} accounts. {extra}It is now {days} days and {hours} hours old.`,
    },
};

const views = {
    Home: {
      heading: "Good Death",
      subheading: "🕯️ Opens Sept 4 🕯️",
      para1: "Good Death is a new set of interactions available to those who have cared for lifeforms.",
      para2: "First, lifeforms older than one year will be able to die a new way - not by disappearing (because you forgot about them) but by intentionally transforming into something new. They will no longer need to change caregiver every 90 days.",
      para3: "Secondly, all addresses that cared for lifeforms before March 6 will be able to participate in a remembrance vigil, looking back at the lifeforms they engaged with and resulting in a new mint shaped by those interactions.",
    },
    SplashPanel: {
      para1: "This page is hosts two new interactions related to lifeforms",
      para2: "The first is open to all addresses that cared for lifeforms prior to March 6, 2024. It's called Memoryforms, and is shaped by the kinds of interactions you had with lifeforms.",
      para3: "The second is a new kind of death. Lifeforms have always been able to die by disappearing, but now lifeforms older than one year can cross the Bridge to Ethereum Mainnet and die (or evolve, if you prefer that metaphor) in a new, intentional, way.",
      para4: "Connect your wallet to check eligibility",
      para5: "Both of these mints are fully onchain, and fees may vary from $30 to $300, therefore you are strongly advised to mint when gas prices are low. Many thanks to IDEO for their support of this project during a 2024 Creative Residency"
    },
    BridgeMint: {
      para1: "This interaction will move this lifeform across the bridge between life and death.",
      para2: "In its new form, it will not need to be change owner every 90 days, but it also be something else: A Deathform",
      para3: "The first step for this interaction is to approve Charon (the ferrycontract) to transfer your lifeform. You will then pay Charon to transport the lifeform over the Wormhole Bridge, where it will eventually arrive on Ethereum Mainnet. The gas fees are high to guarantee no out of gas errors on the other side of the bridge, but you will be refunded any unused portion in ETH. Please also be patient, the bridge crossing will take about half an hour",
      para4: "This is one-way interaction and it is destructive: Lifeforms that cross the bridge can never return to Polygon."
    }
};

export const patterns = {
  "Distinguished Caretaker": "You interacted with lifeforms a lot. You were in the top 10% of caregivers",
  "Creator": "You created a lifeform",
  "Evangelist": "You distributed lifeforms widely",
  "Pod Mother": "You created at least 7 lifeforms",
  "Killer": "You killed a lifeform",
  "Community Menace": "You killed at least 4 lifeforms",
  "Introvert": "You sent lifeforms to only one other caregiver, but you interacted with them multiple times",
  "Forgetful": "You killed every single lifeform you created"
}

export const archetypes = {
  "Brief Visitor": "This lifeform was not alive very long, it only had one caregiver",
  "Long-lived": "This lifeform lived for more than a year",
  "Highly-esteemed": "This lifeform has been alive for more than a year and is still alive at the time of the Memoryforms mint (Sept 2024)",
  "Beloved Companion": "This lifeform was cared for by only two caregivers, but they cared for it repeatedly",
  "Wanderer": "This lifeform lived for more than a year, but no one cared for it more than once. Wanderers are the rarest lifeform archetype.",
  "Frequent traveller": "This lifeforms swapped caregivers more often than was needed to stay alive"
}

const copy = {
  title: "Good Death",
  default: {
    buttonSubmit: "Submit",
    connecting: "connecting ...",
  },
  ...components,
  ...views,
  archetypes,
  patterns
};

export default copy;